export default function Problems() {
  const problems = [
    {
      icon: 'ri-compass-line',
      title: 'Falta de estrategia clara',
      description:
        'Acciones dispersas sin un plan integral que conecte marketing y ventas.',
    },
    {
      icon: 'ri-funds-line',
      title: 'Inversión sin resultados',
      description:
        'Presupuesto en publicidad que no genera leads calificados ni retorno medible.',
    },
    {
      icon: 'ri-team-line',
      title: 'Equipos sin acompañamiento',
      description:
        'Áreas comerciales que necesitan capacitación y herramientas para crecer.',
    },
    {
      icon: 'ri-links-line',
      title: 'Canales desalineados',
      description:
        'Mensajes inconsistentes que debilitan el posicionamiento de la marca.',
    },
  ];

  return (
    <section className="py-20 px-6 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-primary mb-4">
            Entendemos tus desafíos
          </h2>
          <p className="text-xl text-secondary max-w-3xl mx-auto">
            Trabajamos con empresas B2B que buscan profesionalizar su marketing y
            potenciar sus resultados comerciales
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {problems.map((problem, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition-all border border-gray-100 hover:border-accent"
            >
              <div className="w-14 h-14 bg-accent/10 rounded-lg flex items-center justify-center mb-6">
                <i className={`${problem.icon} text-3xl text-accent`}></i>
              </div>
              <h3 className="text-xl font-bold text-primary mb-3">
                {problem.title}
              </h3>
              <p className="text-secondary leading-relaxed">{problem.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
